<template>
  <div
    :class="
      'date-input' +
        (disabled ? ' disabled' : '') +
        (flatPickrConfig.mode == 'range' ? ' dateRangeInput' : '')
    "
  >
    <div v-if="disabled" class="disabledOverlay"></div>

    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div
        class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
      >
        <div ref="picker" class="vs-con-input">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <flat-pickr
            :id="`input-${name}`"
            v-model="internalValue"
            class="w-full data-input"
            :config="flatPickrConfig"
            :placeholder="placeholder"
            :name="name"
            :class="{ error: errors.length }"
            :default-date="defaultDate"
            @on-year-change="dispatchYearChange"
          />
          <i class="fal fa-calendar-alt"></i>
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { German } from "flatpickr/dist/l10n/de";
import moment from "moment";

export default {
  components: {
    flatPickr
  },
  props: {
    value: { type: [String, Number, Object, Date, Array], default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, default: null },
    config: {
      type: [Object],
      default: () => ({})
    },
    returnRawDate: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    defaultDate: {
      type: Array
    }
  },
  computed: {
    internalValue: {
      get() {
        if (this.flatPickrConfig.mode === "range") {
          if (this.value) {
            return this.value;
          } else {
            return null;
          }
        }
        if (this.value && typeof this.value === "string") {
          // TODO: Remove workaround for old year only format
          let parts = this.value.split("-");

          if (parts[1] === "00") {
            return parts[0] + "-01-" + parts[2];
          }
        }

        if (this.value instanceof moment) {
          return this.value.toDate();
        }

        return this.value;
      },
      set(value) {
        if (this.flatPickrConfig.mode === "range" && !this.returnRawDate) {
          this.$emit("input", value);
        } else if (value && moment(value).isValid()) {
          if (this.returnRawDate) {
            this.$emit("input", value);
          } else {
            this.$emit("input", moment(value).toISOString());
          }
        } else if (this.returnRawDate) {
          this.$emit("input", value);
        } else {
          this.$emit("input", null);
        }
      }
    },
    flatPickrConfig() {
      return Object.assign(
        {
          locale: German,
          altInput: true,
          altFormat: "d.m.Y",
          dateFormat: "Y-m-d",
          allowInput: true
        },
        this.config
      );
    }
  },
  mounted() {
    this.isMounted = true;

    this.$refs.picker
      .querySelector("input.form-control.input")
      .addEventListener("blur", this.dispatchEnter);
  },
  beforeDestroy() {
    this.$refs.picker
      .querySelector("input.form-control.input")
      .removeEventListener("blur", this.dispatchEnter);
  },
  methods: {
    dispatchEnter() {
      if (this.$refs.picker.querySelector("input.form-control.input").value) {
        const event = new KeyboardEvent("keydown", {
          view: window,
          keyCode: 13,
          bubbles: true,
          cancelable: true
        });

        this.$refs.picker
          .querySelector("input.form-control.input")
          .dispatchEvent(event);
      }
    },
    dispatchYearChange(v) {
      if (this.value && typeof this.value === "string") {
        let parts = this.value.split("-");
        for (const i in parts) {
          if (parts[i].length === 4) {
            parts[i] = v;
          }
        }

        this.$emit("input", parts.join("-"));
      }
    }
  }
};
</script>
<style scoped>
.date-input.disabled {
  opacity: 0.5;
  position: relative;
}
.disabledOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.dateRangeInput {
  min-width: 40ch;
}
</style>
